<template>
  <v-textarea
    :label="getTitle(cell)"
    :placeholder="placeholderText"
    v-model="input[cellKey]"
    rows="1"
    auto-grow
    clearable
    outlined
    :persistent-placeholder="placeholderText.length > 0"
  />
</template>

<script>
import { getTitle } from './wb-common';

export default {
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  data: () => ({ getTitle }),
  computed: {
    input: {
      get() {
        return this.$store.state[this.namespace].formInput;
      },
      set(val) {
        this.$store.state[this.namespace].formInput = val;
      },
    },
    title() {
      return this.cell.placeholderText ? this.$t(this.cell.placeholderText) : this.$t(this.cell.title);
    },
    cellKey() {
      return this.cell.key + this.mIndex;
    },
    placeholderText() {
      return this.cell.placeholderText ? this.$t(this.cell.placeholderText) : '';
    },
  },
  updated() {
    if (!(this.cellKey in this.input)) {
      let initValue = '';
      if (this.cell.prefilledUserField) {
        let user = localStorage.getItem('user');
        if (user) {
          user = JSON.parse(user);
          if (this.cell.prefilledUserField === 'firstname') {
            if (user.firstName) {
              initValue = user.firstName;
            }
          }
          if (this.cell.prefilledUserField === 'lastname') {
            if (user.lastName) {
              initValue = user.lastName;
            }
          }
          if (this.cell.prefilledUserField === 'employeeNumber') {
            if (user.employeeNr) {
              initValue = user.employeeNr;
            }
          }
          if (this.cell.prefilledUserField === 'email') {
            if (user.email) {
              initValue = user.email;
            }
          }
          if (this.cell.prefilledUserField === 'username') {
            if (user.username) {
              initValue = user.userName;
            }
          }
          if (this.cell.prefilledUserField === 'id') {
            if (user.id) {
              initValue = user.id;
            }
          }
        }
      }
      this.$set(this.input, this.cellKey, initValue);
    }
  },
};
</script>

<style>
textarea::-webkit-input-placeholder {
  padding-top: 9px;
}

textarea::-moz-input-placeholder {
  padding-top: 9px;
}

textarea:-moz-input-placeholder {
  padding-top: 9px;
}

textarea:-ms-input-placeholder {
  padding-top: 9px;
}
</style>
